import styled from 'styled-components';
export var Row = styled.div.withConfig({
  displayName: "Rowstyles__Row",
  componentId: "keen-widget-settings__sc-1sjvcgo-0"
})(["&&&{display:flex;align-items:center;column-gap:10px;margin-top:15px;}"]);